module.exports = __webpack_public_path__ + "img/drumstick-bite.f6166a47.svg";